"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStrategyHelperFactory = void 0;
const required_1 = require("../required/required");
const lodash_1 = require("lodash");
exports.getStrategyHelperFactory = (nftRoom, publicKeySOfCaller) => {
    const verifyJSON = () => {
        required_1.requiredDefined(nftRoom, {
            code: 0,
            content: nftRoom,
            message: 'nft must be an object'
        });
        required_1.requiredType(nftRoom, 'object', {
            code: 1,
            message: 'nft room must be an object'
        });
        required_1.requiredDefined(nftRoom.strategies, {
            code: 2,
            content: nftRoom,
            message: 'nft.strategies must be defined and must be an array of array [[]].'
        });
        const checkStrategies = (strats, stratlabel) => {
            const error = (subCode = 0) => ({
                code: 3,
                subCode,
                content: nftRoom,
                message: `strategies of ${stratlabel} must be defined and must be an array of array [[]].`
            });
            required_1.requiredType(strats, 'array', error(1));
            required_1.required(strats.length > 0, error(2));
            strats.forEach(strat => {
                required_1.requiredType(strat, 'array', error(3));
                strat.forEach(subStrat => {
                    required_1.requiredDefined(subStrat.name, {
                        code: 4,
                        content: nftRoom,
                        message: 'Your strategy has no name.'
                    });
                });
            });
        };
        required_1.requiredDefined(nftRoom.strategies, 'main strategies should be defined');
        checkStrategies(nftRoom.strategies, 'main');
        if (nftRoom.sections) {
            nftRoom.sections.forEach(section => {
                if (section.readStrategies) {
                    checkStrategies(section.readStrategies, `${section.id}-readStrategies`);
                }
                if (section.writeStrategies) {
                    checkStrategies(section.writeStrategies, `${section.id}-readStrategies`);
                }
            });
        }
    };
    verifyJSON();
    const replaceAddressInStrategies = (strategies) => {
        const clonedStrategies = lodash_1.cloneDeep(strategies);
        if (publicKeySOfCaller) {
            return clonedStrategies
                .map(orStrategy => orStrategy.map(d => {
                d.addresses = publicKeySOfCaller;
                return d;
            }));
        }
        else {
            console.warn('strategies are return without an address');
            return clonedStrategies;
        }
    };
    const getStrategy = (key) => (sectionId) => {
        if (sectionId) {
            const section = nftRoom.sections.find(d => d.id === sectionId);
            required_1.requiredDefined(section, `${sectionId} does not exist on this nft room`);
            const readStrategy = section[key];
            if (readStrategy) {
                return replaceAddressInStrategies(readStrategy);
            }
        }
        return replaceAddressInStrategies(nftRoom.strategies) || [[]];
    };
    return {
        getSectionReadStrategies: getStrategy('readStrategies'),
        getSectionWriteStrategies: getStrategy('writeStrategies'),
        getRoomStrategies: getStrategy()
    };
};
//# sourceMappingURL=getStrategyHelper.helper.js.map